export default __webpack_public_path__ + "static/media/ok.3c6c64e6.png";